/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RecoverPasswordRouteImport } from './routes/recover-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as LayoutIndexRouteImport } from './routes/_layout/index'
import { Route as LayoutVendorsRouteImport } from './routes/_layout/vendors'
import { Route as LayoutUsersRouteImport } from './routes/_layout/users'
import { Route as LayoutSettingsRouteImport } from './routes/_layout/settings'
import { Route as LayoutProvidersRouteImport } from './routes/_layout/providers'
import { Route as LayoutProviderRouteImport } from './routes/_layout/provider'
import { Route as LayoutClientsRouteImport } from './routes/_layout/clients'
import { Route as LayoutClientRouteImport } from './routes/_layout/client'
import { Route as LayoutProviderSurveysRouteImport } from './routes/_layout/provider/surveys'
import { Route as LayoutProviderServicecatalogRouteImport } from './routes/_layout/provider/servicecatalog'
import { Route as LayoutProviderPurchasecatalogRouteImport } from './routes/_layout/provider/purchasecatalog'
import { Route as LayoutProviderProviderusertypesRouteImport } from './routes/_layout/provider/providerusertypes'
import { Route as LayoutProviderProviderdashboardRouteImport } from './routes/_layout/provider/providerdashboard'
import { Route as LayoutProviderClienttypesRouteImport } from './routes/_layout/provider/clienttypes'
import { Route as LayoutProviderBudgetcategoriesRouteImport } from './routes/_layout/provider/budgetcategories'
import { Route as LayoutProviderProviderusersIndexRouteImport } from './routes/_layout/provider/providerusers/index'
import { Route as LayoutProviderProvidergroupsIndexRouteImport } from './routes/_layout/provider/providergroups/index'
import { Route as LayoutProviderProviderclientsIndexRouteImport } from './routes/_layout/provider/providerclients/index'
import { Route as LayoutProviderProviderusersEditRouteImport } from './routes/_layout/provider/providerusers/edit'
import { Route as LayoutProviderProviderusersProviderIdRouteImport } from './routes/_layout/provider/providerusers/$providerId'
import { Route as LayoutProviderProvidergroupsEditRouteImport } from './routes/_layout/provider/providergroups/edit'
import { Route as LayoutProviderProvidergroupsProviderIdRouteImport } from './routes/_layout/provider/providergroups/$providerId'
import { Route as LayoutProviderProviderclientsEditRouteImport } from './routes/_layout/provider/providerclients/edit'
import { Route as LayoutProviderProviderclientsProviderIdRouteImport } from './routes/_layout/provider/providerclients/$providerId'

const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RecoverPasswordRoute = RecoverPasswordRouteImport.update({
  id: '/recover-password',
  path: '/recover-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutRoute = LayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutIndexRoute = LayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutVendorsRoute = LayoutVendorsRouteImport.update({
  id: '/vendors',
  path: '/vendors',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutUsersRoute = LayoutUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutSettingsRoute = LayoutSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutProvidersRoute = LayoutProvidersRouteImport.update({
  id: '/providers',
  path: '/providers',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutProviderRoute = LayoutProviderRouteImport.update({
  id: '/provider',
  path: '/provider',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutClientsRoute = LayoutClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutClientRoute = LayoutClientRouteImport.update({
  id: '/client',
  path: '/client',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutProviderSurveysRoute = LayoutProviderSurveysRouteImport.update({
  id: '/surveys',
  path: '/surveys',
  getParentRoute: () => LayoutProviderRoute,
} as any)
const LayoutProviderServicecatalogRoute =
  LayoutProviderServicecatalogRouteImport.update({
    id: '/servicecatalog',
    path: '/servicecatalog',
    getParentRoute: () => LayoutProviderRoute,
  } as any)
const LayoutProviderPurchasecatalogRoute =
  LayoutProviderPurchasecatalogRouteImport.update({
    id: '/purchasecatalog',
    path: '/purchasecatalog',
    getParentRoute: () => LayoutProviderRoute,
  } as any)
const LayoutProviderProviderusertypesRoute =
  LayoutProviderProviderusertypesRouteImport.update({
    id: '/providerusertypes',
    path: '/providerusertypes',
    getParentRoute: () => LayoutProviderRoute,
  } as any)
const LayoutProviderProviderdashboardRoute =
  LayoutProviderProviderdashboardRouteImport.update({
    id: '/providerdashboard',
    path: '/providerdashboard',
    getParentRoute: () => LayoutProviderRoute,
  } as any)
const LayoutProviderClienttypesRoute =
  LayoutProviderClienttypesRouteImport.update({
    id: '/clienttypes',
    path: '/clienttypes',
    getParentRoute: () => LayoutProviderRoute,
  } as any)
const LayoutProviderBudgetcategoriesRoute =
  LayoutProviderBudgetcategoriesRouteImport.update({
    id: '/budgetcategories',
    path: '/budgetcategories',
    getParentRoute: () => LayoutProviderRoute,
  } as any)
const LayoutProviderProviderusersIndexRoute =
  LayoutProviderProviderusersIndexRouteImport.update({
    id: '/providerusers/',
    path: '/providerusers/',
    getParentRoute: () => LayoutProviderRoute,
  } as any)
const LayoutProviderProvidergroupsIndexRoute =
  LayoutProviderProvidergroupsIndexRouteImport.update({
    id: '/providergroups/',
    path: '/providergroups/',
    getParentRoute: () => LayoutProviderRoute,
  } as any)
const LayoutProviderProviderclientsIndexRoute =
  LayoutProviderProviderclientsIndexRouteImport.update({
    id: '/providerclients/',
    path: '/providerclients/',
    getParentRoute: () => LayoutProviderRoute,
  } as any)
const LayoutProviderProviderusersEditRoute =
  LayoutProviderProviderusersEditRouteImport.update({
    id: '/providerusers/edit',
    path: '/providerusers/edit',
    getParentRoute: () => LayoutProviderRoute,
  } as any)
const LayoutProviderProviderusersProviderIdRoute =
  LayoutProviderProviderusersProviderIdRouteImport.update({
    id: '/providerusers/$providerId',
    path: '/providerusers/$providerId',
    getParentRoute: () => LayoutProviderRoute,
  } as any)
const LayoutProviderProvidergroupsEditRoute =
  LayoutProviderProvidergroupsEditRouteImport.update({
    id: '/providergroups/edit',
    path: '/providergroups/edit',
    getParentRoute: () => LayoutProviderRoute,
  } as any)
const LayoutProviderProvidergroupsProviderIdRoute =
  LayoutProviderProvidergroupsProviderIdRouteImport.update({
    id: '/providergroups/$providerId',
    path: '/providergroups/$providerId',
    getParentRoute: () => LayoutProviderRoute,
  } as any)
const LayoutProviderProviderclientsEditRoute =
  LayoutProviderProviderclientsEditRouteImport.update({
    id: '/providerclients/edit',
    path: '/providerclients/edit',
    getParentRoute: () => LayoutProviderRoute,
  } as any)
const LayoutProviderProviderclientsProviderIdRoute =
  LayoutProviderProviderclientsProviderIdRouteImport.update({
    id: '/providerclients/$providerId',
    path: '/providerclients/$providerId',
    getParentRoute: () => LayoutProviderRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof LayoutIndexRoute
  '/login': typeof LoginRoute
  '/recover-password': typeof RecoverPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/client': typeof LayoutClientRoute
  '/clients': typeof LayoutClientsRoute
  '/provider': typeof LayoutProviderRouteWithChildren
  '/providers': typeof LayoutProvidersRoute
  '/settings': typeof LayoutSettingsRoute
  '/users': typeof LayoutUsersRoute
  '/vendors': typeof LayoutVendorsRoute
  '/provider/budgetcategories': typeof LayoutProviderBudgetcategoriesRoute
  '/provider/clienttypes': typeof LayoutProviderClienttypesRoute
  '/provider/providerdashboard': typeof LayoutProviderProviderdashboardRoute
  '/provider/providerusertypes': typeof LayoutProviderProviderusertypesRoute
  '/provider/purchasecatalog': typeof LayoutProviderPurchasecatalogRoute
  '/provider/servicecatalog': typeof LayoutProviderServicecatalogRoute
  '/provider/surveys': typeof LayoutProviderSurveysRoute
  '/provider/providerclients/$providerId': typeof LayoutProviderProviderclientsProviderIdRoute
  '/provider/providerclients/edit': typeof LayoutProviderProviderclientsEditRoute
  '/provider/providergroups/$providerId': typeof LayoutProviderProvidergroupsProviderIdRoute
  '/provider/providergroups/edit': typeof LayoutProviderProvidergroupsEditRoute
  '/provider/providerusers/$providerId': typeof LayoutProviderProviderusersProviderIdRoute
  '/provider/providerusers/edit': typeof LayoutProviderProviderusersEditRoute
  '/provider/providerclients/': typeof LayoutProviderProviderclientsIndexRoute
  '/provider/providergroups/': typeof LayoutProviderProvidergroupsIndexRoute
  '/provider/providerusers/': typeof LayoutProviderProviderusersIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/recover-password': typeof RecoverPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/client': typeof LayoutClientRoute
  '/clients': typeof LayoutClientsRoute
  '/provider': typeof LayoutProviderRouteWithChildren
  '/providers': typeof LayoutProvidersRoute
  '/settings': typeof LayoutSettingsRoute
  '/users': typeof LayoutUsersRoute
  '/vendors': typeof LayoutVendorsRoute
  '/': typeof LayoutIndexRoute
  '/provider/budgetcategories': typeof LayoutProviderBudgetcategoriesRoute
  '/provider/clienttypes': typeof LayoutProviderClienttypesRoute
  '/provider/providerdashboard': typeof LayoutProviderProviderdashboardRoute
  '/provider/providerusertypes': typeof LayoutProviderProviderusertypesRoute
  '/provider/purchasecatalog': typeof LayoutProviderPurchasecatalogRoute
  '/provider/servicecatalog': typeof LayoutProviderServicecatalogRoute
  '/provider/surveys': typeof LayoutProviderSurveysRoute
  '/provider/providerclients/$providerId': typeof LayoutProviderProviderclientsProviderIdRoute
  '/provider/providerclients/edit': typeof LayoutProviderProviderclientsEditRoute
  '/provider/providergroups/$providerId': typeof LayoutProviderProvidergroupsProviderIdRoute
  '/provider/providergroups/edit': typeof LayoutProviderProvidergroupsEditRoute
  '/provider/providerusers/$providerId': typeof LayoutProviderProviderusersProviderIdRoute
  '/provider/providerusers/edit': typeof LayoutProviderProviderusersEditRoute
  '/provider/providerclients': typeof LayoutProviderProviderclientsIndexRoute
  '/provider/providergroups': typeof LayoutProviderProvidergroupsIndexRoute
  '/provider/providerusers': typeof LayoutProviderProviderusersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_layout': typeof LayoutRouteWithChildren
  '/login': typeof LoginRoute
  '/recover-password': typeof RecoverPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/_layout/client': typeof LayoutClientRoute
  '/_layout/clients': typeof LayoutClientsRoute
  '/_layout/provider': typeof LayoutProviderRouteWithChildren
  '/_layout/providers': typeof LayoutProvidersRoute
  '/_layout/settings': typeof LayoutSettingsRoute
  '/_layout/users': typeof LayoutUsersRoute
  '/_layout/vendors': typeof LayoutVendorsRoute
  '/_layout/': typeof LayoutIndexRoute
  '/_layout/provider/budgetcategories': typeof LayoutProviderBudgetcategoriesRoute
  '/_layout/provider/clienttypes': typeof LayoutProviderClienttypesRoute
  '/_layout/provider/providerdashboard': typeof LayoutProviderProviderdashboardRoute
  '/_layout/provider/providerusertypes': typeof LayoutProviderProviderusertypesRoute
  '/_layout/provider/purchasecatalog': typeof LayoutProviderPurchasecatalogRoute
  '/_layout/provider/servicecatalog': typeof LayoutProviderServicecatalogRoute
  '/_layout/provider/surveys': typeof LayoutProviderSurveysRoute
  '/_layout/provider/providerclients/$providerId': typeof LayoutProviderProviderclientsProviderIdRoute
  '/_layout/provider/providerclients/edit': typeof LayoutProviderProviderclientsEditRoute
  '/_layout/provider/providergroups/$providerId': typeof LayoutProviderProvidergroupsProviderIdRoute
  '/_layout/provider/providergroups/edit': typeof LayoutProviderProvidergroupsEditRoute
  '/_layout/provider/providerusers/$providerId': typeof LayoutProviderProviderusersProviderIdRoute
  '/_layout/provider/providerusers/edit': typeof LayoutProviderProviderusersEditRoute
  '/_layout/provider/providerclients/': typeof LayoutProviderProviderclientsIndexRoute
  '/_layout/provider/providergroups/': typeof LayoutProviderProvidergroupsIndexRoute
  '/_layout/provider/providerusers/': typeof LayoutProviderProviderusersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/recover-password'
    | '/reset-password'
    | '/signup'
    | '/unauthorized'
    | '/client'
    | '/clients'
    | '/provider'
    | '/providers'
    | '/settings'
    | '/users'
    | '/vendors'
    | '/provider/budgetcategories'
    | '/provider/clienttypes'
    | '/provider/providerdashboard'
    | '/provider/providerusertypes'
    | '/provider/purchasecatalog'
    | '/provider/servicecatalog'
    | '/provider/surveys'
    | '/provider/providerclients/$providerId'
    | '/provider/providerclients/edit'
    | '/provider/providergroups/$providerId'
    | '/provider/providergroups/edit'
    | '/provider/providerusers/$providerId'
    | '/provider/providerusers/edit'
    | '/provider/providerclients/'
    | '/provider/providergroups/'
    | '/provider/providerusers/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/recover-password'
    | '/reset-password'
    | '/signup'
    | '/unauthorized'
    | '/client'
    | '/clients'
    | '/provider'
    | '/providers'
    | '/settings'
    | '/users'
    | '/vendors'
    | '/'
    | '/provider/budgetcategories'
    | '/provider/clienttypes'
    | '/provider/providerdashboard'
    | '/provider/providerusertypes'
    | '/provider/purchasecatalog'
    | '/provider/servicecatalog'
    | '/provider/surveys'
    | '/provider/providerclients/$providerId'
    | '/provider/providerclients/edit'
    | '/provider/providergroups/$providerId'
    | '/provider/providergroups/edit'
    | '/provider/providerusers/$providerId'
    | '/provider/providerusers/edit'
    | '/provider/providerclients'
    | '/provider/providergroups'
    | '/provider/providerusers'
  id:
    | '__root__'
    | '/_layout'
    | '/login'
    | '/recover-password'
    | '/reset-password'
    | '/signup'
    | '/unauthorized'
    | '/_layout/client'
    | '/_layout/clients'
    | '/_layout/provider'
    | '/_layout/providers'
    | '/_layout/settings'
    | '/_layout/users'
    | '/_layout/vendors'
    | '/_layout/'
    | '/_layout/provider/budgetcategories'
    | '/_layout/provider/clienttypes'
    | '/_layout/provider/providerdashboard'
    | '/_layout/provider/providerusertypes'
    | '/_layout/provider/purchasecatalog'
    | '/_layout/provider/servicecatalog'
    | '/_layout/provider/surveys'
    | '/_layout/provider/providerclients/$providerId'
    | '/_layout/provider/providerclients/edit'
    | '/_layout/provider/providergroups/$providerId'
    | '/_layout/provider/providergroups/edit'
    | '/_layout/provider/providerusers/$providerId'
    | '/_layout/provider/providerusers/edit'
    | '/_layout/provider/providerclients/'
    | '/_layout/provider/providergroups/'
    | '/_layout/provider/providerusers/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LayoutRoute: typeof LayoutRouteWithChildren
  LoginRoute: typeof LoginRoute
  RecoverPasswordRoute: typeof RecoverPasswordRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
  UnauthorizedRoute: typeof UnauthorizedRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recover-password': {
      id: '/recover-password'
      path: '/recover-password'
      fullPath: '/recover-password'
      preLoaderRoute: typeof RecoverPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout/': {
      id: '/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LayoutIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/vendors': {
      id: '/_layout/vendors'
      path: '/vendors'
      fullPath: '/vendors'
      preLoaderRoute: typeof LayoutVendorsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/users': {
      id: '/_layout/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof LayoutUsersRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/settings': {
      id: '/_layout/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof LayoutSettingsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/providers': {
      id: '/_layout/providers'
      path: '/providers'
      fullPath: '/providers'
      preLoaderRoute: typeof LayoutProvidersRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/provider': {
      id: '/_layout/provider'
      path: '/provider'
      fullPath: '/provider'
      preLoaderRoute: typeof LayoutProviderRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/clients': {
      id: '/_layout/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof LayoutClientsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/client': {
      id: '/_layout/client'
      path: '/client'
      fullPath: '/client'
      preLoaderRoute: typeof LayoutClientRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/provider/surveys': {
      id: '/_layout/provider/surveys'
      path: '/surveys'
      fullPath: '/provider/surveys'
      preLoaderRoute: typeof LayoutProviderSurveysRouteImport
      parentRoute: typeof LayoutProviderRoute
    }
    '/_layout/provider/servicecatalog': {
      id: '/_layout/provider/servicecatalog'
      path: '/servicecatalog'
      fullPath: '/provider/servicecatalog'
      preLoaderRoute: typeof LayoutProviderServicecatalogRouteImport
      parentRoute: typeof LayoutProviderRoute
    }
    '/_layout/provider/purchasecatalog': {
      id: '/_layout/provider/purchasecatalog'
      path: '/purchasecatalog'
      fullPath: '/provider/purchasecatalog'
      preLoaderRoute: typeof LayoutProviderPurchasecatalogRouteImport
      parentRoute: typeof LayoutProviderRoute
    }
    '/_layout/provider/providerusertypes': {
      id: '/_layout/provider/providerusertypes'
      path: '/providerusertypes'
      fullPath: '/provider/providerusertypes'
      preLoaderRoute: typeof LayoutProviderProviderusertypesRouteImport
      parentRoute: typeof LayoutProviderRoute
    }
    '/_layout/provider/providerdashboard': {
      id: '/_layout/provider/providerdashboard'
      path: '/providerdashboard'
      fullPath: '/provider/providerdashboard'
      preLoaderRoute: typeof LayoutProviderProviderdashboardRouteImport
      parentRoute: typeof LayoutProviderRoute
    }
    '/_layout/provider/clienttypes': {
      id: '/_layout/provider/clienttypes'
      path: '/clienttypes'
      fullPath: '/provider/clienttypes'
      preLoaderRoute: typeof LayoutProviderClienttypesRouteImport
      parentRoute: typeof LayoutProviderRoute
    }
    '/_layout/provider/budgetcategories': {
      id: '/_layout/provider/budgetcategories'
      path: '/budgetcategories'
      fullPath: '/provider/budgetcategories'
      preLoaderRoute: typeof LayoutProviderBudgetcategoriesRouteImport
      parentRoute: typeof LayoutProviderRoute
    }
    '/_layout/provider/providerusers/': {
      id: '/_layout/provider/providerusers/'
      path: '/providerusers'
      fullPath: '/provider/providerusers/'
      preLoaderRoute: typeof LayoutProviderProviderusersIndexRouteImport
      parentRoute: typeof LayoutProviderRoute
    }
    '/_layout/provider/providergroups/': {
      id: '/_layout/provider/providergroups/'
      path: '/providergroups'
      fullPath: '/provider/providergroups/'
      preLoaderRoute: typeof LayoutProviderProvidergroupsIndexRouteImport
      parentRoute: typeof LayoutProviderRoute
    }
    '/_layout/provider/providerclients/': {
      id: '/_layout/provider/providerclients/'
      path: '/providerclients'
      fullPath: '/provider/providerclients/'
      preLoaderRoute: typeof LayoutProviderProviderclientsIndexRouteImport
      parentRoute: typeof LayoutProviderRoute
    }
    '/_layout/provider/providerusers/edit': {
      id: '/_layout/provider/providerusers/edit'
      path: '/providerusers/edit'
      fullPath: '/provider/providerusers/edit'
      preLoaderRoute: typeof LayoutProviderProviderusersEditRouteImport
      parentRoute: typeof LayoutProviderRoute
    }
    '/_layout/provider/providerusers/$providerId': {
      id: '/_layout/provider/providerusers/$providerId'
      path: '/providerusers/$providerId'
      fullPath: '/provider/providerusers/$providerId'
      preLoaderRoute: typeof LayoutProviderProviderusersProviderIdRouteImport
      parentRoute: typeof LayoutProviderRoute
    }
    '/_layout/provider/providergroups/edit': {
      id: '/_layout/provider/providergroups/edit'
      path: '/providergroups/edit'
      fullPath: '/provider/providergroups/edit'
      preLoaderRoute: typeof LayoutProviderProvidergroupsEditRouteImport
      parentRoute: typeof LayoutProviderRoute
    }
    '/_layout/provider/providergroups/$providerId': {
      id: '/_layout/provider/providergroups/$providerId'
      path: '/providergroups/$providerId'
      fullPath: '/provider/providergroups/$providerId'
      preLoaderRoute: typeof LayoutProviderProvidergroupsProviderIdRouteImport
      parentRoute: typeof LayoutProviderRoute
    }
    '/_layout/provider/providerclients/edit': {
      id: '/_layout/provider/providerclients/edit'
      path: '/providerclients/edit'
      fullPath: '/provider/providerclients/edit'
      preLoaderRoute: typeof LayoutProviderProviderclientsEditRouteImport
      parentRoute: typeof LayoutProviderRoute
    }
    '/_layout/provider/providerclients/$providerId': {
      id: '/_layout/provider/providerclients/$providerId'
      path: '/providerclients/$providerId'
      fullPath: '/provider/providerclients/$providerId'
      preLoaderRoute: typeof LayoutProviderProviderclientsProviderIdRouteImport
      parentRoute: typeof LayoutProviderRoute
    }
  }
}

interface LayoutProviderRouteChildren {
  LayoutProviderBudgetcategoriesRoute: typeof LayoutProviderBudgetcategoriesRoute
  LayoutProviderClienttypesRoute: typeof LayoutProviderClienttypesRoute
  LayoutProviderProviderdashboardRoute: typeof LayoutProviderProviderdashboardRoute
  LayoutProviderProviderusertypesRoute: typeof LayoutProviderProviderusertypesRoute
  LayoutProviderPurchasecatalogRoute: typeof LayoutProviderPurchasecatalogRoute
  LayoutProviderServicecatalogRoute: typeof LayoutProviderServicecatalogRoute
  LayoutProviderSurveysRoute: typeof LayoutProviderSurveysRoute
  LayoutProviderProviderclientsProviderIdRoute: typeof LayoutProviderProviderclientsProviderIdRoute
  LayoutProviderProviderclientsEditRoute: typeof LayoutProviderProviderclientsEditRoute
  LayoutProviderProvidergroupsProviderIdRoute: typeof LayoutProviderProvidergroupsProviderIdRoute
  LayoutProviderProvidergroupsEditRoute: typeof LayoutProviderProvidergroupsEditRoute
  LayoutProviderProviderusersProviderIdRoute: typeof LayoutProviderProviderusersProviderIdRoute
  LayoutProviderProviderusersEditRoute: typeof LayoutProviderProviderusersEditRoute
  LayoutProviderProviderclientsIndexRoute: typeof LayoutProviderProviderclientsIndexRoute
  LayoutProviderProvidergroupsIndexRoute: typeof LayoutProviderProvidergroupsIndexRoute
  LayoutProviderProviderusersIndexRoute: typeof LayoutProviderProviderusersIndexRoute
}

const LayoutProviderRouteChildren: LayoutProviderRouteChildren = {
  LayoutProviderBudgetcategoriesRoute: LayoutProviderBudgetcategoriesRoute,
  LayoutProviderClienttypesRoute: LayoutProviderClienttypesRoute,
  LayoutProviderProviderdashboardRoute: LayoutProviderProviderdashboardRoute,
  LayoutProviderProviderusertypesRoute: LayoutProviderProviderusertypesRoute,
  LayoutProviderPurchasecatalogRoute: LayoutProviderPurchasecatalogRoute,
  LayoutProviderServicecatalogRoute: LayoutProviderServicecatalogRoute,
  LayoutProviderSurveysRoute: LayoutProviderSurveysRoute,
  LayoutProviderProviderclientsProviderIdRoute:
    LayoutProviderProviderclientsProviderIdRoute,
  LayoutProviderProviderclientsEditRoute:
    LayoutProviderProviderclientsEditRoute,
  LayoutProviderProvidergroupsProviderIdRoute:
    LayoutProviderProvidergroupsProviderIdRoute,
  LayoutProviderProvidergroupsEditRoute: LayoutProviderProvidergroupsEditRoute,
  LayoutProviderProviderusersProviderIdRoute:
    LayoutProviderProviderusersProviderIdRoute,
  LayoutProviderProviderusersEditRoute: LayoutProviderProviderusersEditRoute,
  LayoutProviderProviderclientsIndexRoute:
    LayoutProviderProviderclientsIndexRoute,
  LayoutProviderProvidergroupsIndexRoute:
    LayoutProviderProvidergroupsIndexRoute,
  LayoutProviderProviderusersIndexRoute: LayoutProviderProviderusersIndexRoute,
}

const LayoutProviderRouteWithChildren = LayoutProviderRoute._addFileChildren(
  LayoutProviderRouteChildren,
)

interface LayoutRouteChildren {
  LayoutClientRoute: typeof LayoutClientRoute
  LayoutClientsRoute: typeof LayoutClientsRoute
  LayoutProviderRoute: typeof LayoutProviderRouteWithChildren
  LayoutProvidersRoute: typeof LayoutProvidersRoute
  LayoutSettingsRoute: typeof LayoutSettingsRoute
  LayoutUsersRoute: typeof LayoutUsersRoute
  LayoutVendorsRoute: typeof LayoutVendorsRoute
  LayoutIndexRoute: typeof LayoutIndexRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutClientRoute: LayoutClientRoute,
  LayoutClientsRoute: LayoutClientsRoute,
  LayoutProviderRoute: LayoutProviderRouteWithChildren,
  LayoutProvidersRoute: LayoutProvidersRoute,
  LayoutSettingsRoute: LayoutSettingsRoute,
  LayoutUsersRoute: LayoutUsersRoute,
  LayoutVendorsRoute: LayoutVendorsRoute,
  LayoutIndexRoute: LayoutIndexRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  LayoutRoute: LayoutRouteWithChildren,
  LoginRoute: LoginRoute,
  RecoverPasswordRoute: RecoverPasswordRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
  UnauthorizedRoute: UnauthorizedRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
